import { cn } from '@polyai/ui/utils';

export const userMenuStyles = {
  popoverRow: cn(
    'cursor-pointer relative flex items-center justify-between',
    'w-full h-md1 py-xs2 px-sm1 no-underline',
    'bg-background-inverse border-0',
    'hover:bg-background-accent-inverse',
    'focus-visible:[outline:2px_solid_var(--tw-border-focus)] focus-visible:[outline-offset:-2px]',
  ),
  themeRow: cn(
    'relative flex items-center justify-between',
    'w-full h-md1 py-xs2 px-sm1',
    'bg-background-inverse',
  ),
  rowLabel: cn(
    'overflow-hidden',
    "font-['Proxima_Nova',_sans-serif] text-body-regular font-semibold leading-[1.2]",
    'text-secondary-inverse [text-overflow:ellipsis] whitespace-nowrap',
  ),
  rowDivider: cn(
    'absolute right-0 bottom-0 left-0',
    'h-[1px] bg-border-subtle-inverse',
  ),
};
